export const onlyNumbers = (value: string) => value.replace(/\D/g, '');

export const formatCurrency = (value: number) =>
  value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const formatCep = (value: string) => {
  const numbers = onlyNumbers(value).slice(0, 8);
  return numbers.replace(/^(\d{5})(\d)/, '$1-$2');
};

export const formatPhone = (value: string) => {
  const numbers = onlyNumbers(value).slice(0, 11);
  if (numbers.length <= 10) {
    return numbers.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
  }
  return numbers.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
};

export const formatDate = (value: string) =>
  onlyNumbers(value)
    .slice(0, 8)
    .replace(/^(\d{2})(\d)/, '$1/$2')
    .replace(/^(\d{2})\/(\d{2})(\d)/, '$1/$2/$3');

export const TURMAS = ['4', '5/6', '7/8', '9/10', '11 ao 14'];

export const turmaPorIdade = (idade: number) => {
  if (idade <= 4) return TURMAS[0];
  if (idade <= 6) return TURMAS[1];
  if (idade <= 8) return TURMAS[2];
  if (idade <= 10) return TURMAS[3];
  return TURMAS[4];
};

/** Ordena turmas pela faixa etária (4, 5/6, 7/8, 9/10, 11 ao 14); valores fora da lista (ex.: "Sem turma") vão ao final. */
export const compareTurmas = (a: string, b: string) => {
  const indexA = TURMAS.indexOf(a);
  const indexB = TURMAS.indexOf(b);
  const rankA = indexA === -1 ? TURMAS.length : indexA;
  const rankB = indexB === -1 ? TURMAS.length : indexB;
  return rankA !== rankB ? rankA - rankB : a.localeCompare(b, 'pt-BR');
};

/** Aceita dd/mm/aaaa e aaaa-mm-dd; recusa datas que não existem (ex.: 31/02). */
export const parseDataNascimento = (data: string): Date | null => {
  const texto = String(data || '').trim();
  let dia: number;
  let mes: number;
  let ano: number;

  const brasileiro = texto.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  const iso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (brasileiro) {
    dia = Number(brasileiro[1]);
    mes = Number(brasileiro[2]);
    ano = Number(brasileiro[3]);
  } else if (iso) {
    ano = Number(iso[1]);
    mes = Number(iso[2]);
    dia = Number(iso[3]);
  } else {
    return null;
  }

  if (ano < 1900) return null;
  const nascimento = new Date(ano, mes - 1, dia);
  // Se o Date "rolou" (31/02 vira 03/03), a data informada não existe.
  if (nascimento.getFullYear() !== ano || nascimento.getMonth() !== mes - 1 || nascimento.getDate() !== dia) {
    return null;
  }
  if (nascimento.getTime() > Date.now()) return null;
  return nascimento;
};

export const calcularIdade = (data: string) => {
  const nascimento = parseDataNascimento(data);
  if (!nascimento) return 0;
  const hoje = new Date();
  let idade = hoje.getFullYear() - nascimento.getFullYear();
  if (
    hoje.getMonth() < nascimento.getMonth() ||
    (hoje.getMonth() === nascimento.getMonth() && hoje.getDate() < nascimento.getDate())
  ) {
    idade -= 1;
  }
  return Math.max(0, idade);
};

export const fileToCompressedDataUrl = (file: File, maxSize = 640, quality = 0.72) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('file_read_error'));
    reader.onload = () => {
      const image = new Image();
      image.onerror = () => resolve(String(reader.result || ''));
      image.onload = () => {
        const scale = Math.min(1, maxSize / Math.max(image.width, image.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(image.width * scale));
        canvas.height = Math.max(1, Math.round(image.height * scale));
        const context = canvas.getContext('2d');
        if (!context) {
          resolve(String(reader.result || ''));
          return;
        }
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      image.src = String(reader.result || '');
    };
    reader.readAsDataURL(file);
  });
